import { use } from "i18next";
import { EncryptedDataPropTypes } from "../../PropTypes/EncryptedDataPropTypes";
import { UserPropTypes } from "../../PropTypes/UserPropTypes";

const baseURL = `${process.env.REACT_APP_BASE_URL}/api`

let headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
};

// API to update user profile
const updateUserProfileApi = async (
    user: UserPropTypes, // user data
    accessToken: string, // access token
    encryptedPassword?: EncryptedDataPropTypes | null, // password 
    otp?: string,
): Promise<any> => {
    
    console.log('user: ', user);
    const url = `${baseURL}/user/edit`;
    const formData = new FormData();


    user.name && formData.append("name", user.name);
    user.phone && formData.append("phone", user.phone);
    user.email && formData.append("email", user.email);
    user.default_lang_code && formData.append("default_lang_code", user.default_lang_code || 'en');
    user.country !== 0 && formData.append("country_id", user?.country?.toString() || '0');
    encryptedPassword && formData.append("password", encryptedPassword.cipherText);
    encryptedPassword && formData.append("iv", encryptedPassword.iv);
    encryptedPassword && formData.append("salt", encryptedPassword.salt);
    formData.append("company_name", user.company_name ? user.company_name : '');
    formData.append("website", user.website ? user.website : '');
    formData.append("otp", otp ? otp : '');
    user?.is_tour_show && formData.append("is_tour_show", user?.is_tour_show?.toString());


    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + accessToken
            },
            body: formData,
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }

}



export { updateUserProfileApi };